import React, { Component } from "react"
import Raven from "../../utils/raven"

class ErrorHandler extends Component {
  state = { error: null }

  componentDidMount() {
    Raven.config("https://fe84fb6793dd4708b879c5c8cfa99274@sentry.io/292099", {
      environment: process.env.NODE_ENV,
      release: "0e4fdef81448dcfa0e16ecc4433ff3997aa53572",
      ignoreUrls: ["http://localhost:3000/"]
    }).install()
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error })
    Raven.captureException(error, { extra: errorInfo })
  }

  render() {
    if (this.state.error) {
      // Render fallback UI
      return (
        <div
          style={{ padding: 30 }}
          onClick={() => Raven.lastEventId() && Raven.showReportDialog()}
        >
          <p>We're sorry — something's gone wrong.</p>
          <p>
            Our team has been notified, but you can chat with us using the chat
            box below.
          </p>
        </div>
      )
    } else {
      // When there's not an error, render the children untouched
      return this.props.children
    }
  }
}

export default ErrorHandler



// WEBPACK FOOTER //
// ./src/components/error-handler/error-handler.component.js